import getStore from '../store/store';

export function getIsDiscoverManifestLoaded(): boolean {
    const store = getStore();
    return store.isDiscoverManifestLoaded;
}
